import React, { useEffect } from 'react';
import { Button } from '@paypalcorp/pp-react';
import { COLLECT_PUBLIC_CREDENTIAL } from './views';
import { ApplePayButton, ApplePayConsent } from '../common/ApplePay';
export default ({ authEventHandler, emptyPublicCredentialOnClick = false, redirectToOnboardingFlow = false, localizedContent, logger, csrf, csrfNonce, isCookiedUser, options = {}, setApplePayButtonSeen, setPublicCredential, publicCredential = '', publicCredentialType = 'EMAIL', setView, countryCode, view, }) => {
    var _a;
    useEffect(() => {
        authEventHandler({ event: 'signupButtonRendered' });
    }, []);
    const isApplePayEligible = options.applePayOptions && window.ApplePaySession;
    const showApplePayConsent = isApplePayEligible && ((_a = options === null || options === void 0 ? void 0 : options.applePayOptions) === null || _a === void 0 ? void 0 : _a.showConsent);
    logger.flush({ csrf, csrfNonce: csrf ? null : csrfNonce });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "loginSignUpSeparator" },
            React.createElement("span", { className: "textInSeparator" }, localizedContent('or'))),
        isApplePayEligible && (React.createElement("div", { style: { marginBottom: '12px' } },
            React.createElement(ApplePayButton, { authEventHandler: authEventHandler, applePayOptions: options.applePayOptions, setApplePayButtonSeen: setApplePayButtonSeen, view: view }))),
        React.createElement(Button, { secondary: true, onClick: (e) => {
                e.preventDefault();
                logger.track('create_account_clicked');
                logger.flush({ csrf, csrfNonce: csrf ? null : csrfNonce });
                if (isCookiedUser || redirectToOnboardingFlow) {
                    authEventHandler({ event: 'userOptedOut', data: { email: publicCredential, publicCredentialType } });
                }
                else {
                    emptyPublicCredentialOnClick && setPublicCredential('');
                    setView(COLLECT_PUBLIC_CREDENTIAL);
                }
            }, style: { width: '100%' }, id: "buttonCreateAccount", "data-testid": "button-create-account" }, options.signupContent && typeof localizedContent(options.signupContent) === 'string'
            ? localizedContent(options.signupContent)
            : localizedContent('createAccount')),
        showApplePayConsent && (React.createElement("div", { style: { marginBottom: '12px' } },
            React.createElement(ApplePayConsent, { authEventHandler: authEventHandler, countryCode: countryCode, localizedContent: localizedContent, view: view })))));
};
